// Module
var code = "<i class=\"fa fa-chevron-up\" *ngIf=\"sortDirection === 'asc'\"></i> <i class=\"fa fa-chevron-down\" *ngIf=\"sortDirection === 'desc'\"></i> <ng-content></ng-content>";
// Exports
module.exports = code;